import React, { useState } from "react";
import { Card, Dropdown } from "react-bootstrap";
import { FiCalendar } from "react-icons/fi";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip);

export default function DealsByStage() {
  const [filter, setFilter] = useState("This Week");

  const dataMap = {
    "This Week": [180, 140, 200, 120],
    "Last Week": [120, 100, 160, 90],
    "This Month": [220, 180, 240, 150],
  };

  const labels = ["Pipeline", "Follow Up", "Schedule", "Conversion"];

  const data = {
    labels,
    datasets: [
      {
        data: dataMap[filter],
        backgroundColor: [
          "#f26522",
          "#ff8a3d",
          "#f26522",
          "#8b3a0e",
        ],
        borderRadius: 40,
        barThickness: 40,
        hoverBackgroundColor: "#d9541c",
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 10,
      },
    },
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: "#fff",
        titleColor: "#333",
        bodyColor: "#333",
        borderColor: "#ddd",
        borderWidth: 1,
        padding: 10,
        displayColors: false,
        callbacks: {
          title: (ctx) => ctx[0].label,
          label: (ctx) => `Expenses: ${ctx.raw}`,
        },
      },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: {
          color: "#666",
          font: { size: 13 },
        },
      },
      y: {
        beginAtZero: true,
        max: 250, // ✅ FIX: force max to 250
        ticks: {
          stepSize: 50,
          color: "#999",
        },
        grid: {
          color: "#e5e5e5",
          borderDash: [5, 5],
        },
      },
    },
  };

  return (
    <Card className="flex-fill h-100">
      <Card.Header className="d-flex justify-content-between align-items-center card-header-custom">
        <h5 className="mb-0">Deals by Stage</h5>

        <Dropdown>
          <Dropdown.Toggle className="btn-white custom-toggle d-flex align-items-center text-dark">
            <FiCalendar className="me-1" />
            {filter}
          </Dropdown.Toggle>

          <Dropdown.Menu align="end">
            {["This Month", "This Week", "Last Week"].map((item) => (
              <Dropdown.Item key={item} onClick={() => setFilter(item)}>
                {item}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </Card.Header>

      <Card.Body>
        {/* TOP VALUE */}
        <div className="d-flex align-items-center mb-3">
          <h3 className="me-2 fw-bold">$20,245</h3>

          <span
            className="px-2 py-1 me-2"
            style={{
              background: "#e6f7ec",
              color: "#28a745",
              borderRadius: "20px",
              fontSize: "12px",
              fontWeight: "500",
            }}
          >
            ↑ 12%
          </span>

          <span style={{ color: "#888" }}>vs last years</span>
        </div>

        {/* CHART */}
        <div className="mt-2" style={{ height: "280px" }}>
          <Bar data={data} options={options} />
        </div>
      </Card.Body>

      <style>{`
        .btn-white {
          background: #fff;
         border-radius:5px;
border:2px solid #e5e7eb;
          padding: 8px 14px;
          font-size: 14px;
        }
                .card-header-custom{
display:flex;
justify-content:space-between;
align-items:center;
padding:18px;
border-bottom:1px solid #eee;
background:#ffffff;


}

.card-header-custom h5{
margin:0;
font-size:18px;
font-weight:600;
color:#1f2937;
}

        /* ✅ REMOVE BLUE HOVER / CLICK EFFECT */
        .custom-toggle:focus,
        .custom-toggle:active,
        .custom-toggle.show {
          background: #fff !important;
          border-color: #e5e7eb !important;
          color: #111 !important;
          box-shadow: none !important;
        }

        .custom-toggle:hover {
          background: #fff !important;
          border-color: #f97316 !important;
          color: #f97316 !important;
        }

        /* Dropdown menu */
        .dropdown-menu {
          border-radius: 8px;
          padding: 6px;
        }

        .dropdown-item {
          border-radius: 6px;
          font-size: 14px;
        }

        .dropdown-item.active,
        .dropdown-item:active {
          background: #f97316 !important;
          color: #fff !important;
        }

        .dropdown-item:hover {
          background: #fff7ed;
          color: #f97316;
        }
          .dropdown-toggle::after {
  display: none !important;
}
      `}</style>
    </Card>
  );
}